import { t } from "i18next";
import isEmpty from "lodash/isEmpty";
import { UseFieldArrayInsert, UseFieldArrayRemove, UseFieldArrayReturn } from "react-hook-form";

import { colors } from "#app/theme/v1/colors";
import { QuoteRequestLineFormData } from "#modules/quoteRequestLines/types/QuoteRequestLineFormData";
import { Product } from "#modules/quoteRequestLines/views/DetailsPanel/Products/Product";
import { Grid } from "#shared/view/components/Grid";
import { Stack } from "#shared/view/components/Stack";
import { Text } from "#shared/view/components/Text";

export const PRODUCT_TABLE_COLUMS_COUNT = 24;
export const TRASH_SPAN = 1;
export const PRODUCT_NAME_SPAN = 8;
export const PRICE_SPAN = 4;
export const IDLE_QUANTITY_SPAN = 7;
export const EDITING_QUANTITY_SPAN = 4;
export const EDITING_ACTION_SPAN = 3;

export const Products = ({
  productLines,
  removeProduct,
  insertProduct,
}: {
  productLines: UseFieldArrayReturn<QuoteRequestLineFormData, "productLines", "__rhfId">["fields"];
  removeProduct: UseFieldArrayRemove;
  insertProduct: UseFieldArrayInsert<QuoteRequestLineFormData, "productLines">;
}) => {
  const hasProducts = !isEmpty(productLines);
  if (!hasProducts) {
    return <Text c={colors.gray[4]}>Aucun achat</Text>;
  }

  return (
    <>
      <Grid columns={PRODUCT_TABLE_COLUMS_COUNT} gap={0}>
        <Grid.Col span={TRASH_SPAN}></Grid.Col>
        <Grid.Col span={PRODUCT_NAME_SPAN}>
          <Text>{t("quoteRequestLine.purchases.label")}</Text>
        </Grid.Col>
        <Grid.Col span={PRICE_SPAN}>
          <Text>{t("quoteRequestLine.purchases.fixedCost")}</Text>
        </Grid.Col>
        <Grid.Col span={PRICE_SPAN}>
          <Text>{t("quoteRequestLine.purchases.unitCost")}</Text>
        </Grid.Col>
        <Grid.Col span={IDLE_QUANTITY_SPAN}>
          <Text>{t("quoteRequestLine.purchases.quantity")}</Text>
        </Grid.Col>
      </Grid>

      <Stack gap="xs">
        {productLines.map((productLine, index) => (
          <Product
            key={productLine.__rhfId}
            index={index}
            productLineId={productLine.id}
            removeProduct={removeProduct}
            insertProduct={insertProduct}
          />
        ))}
      </Stack>
    </>
  );
};
